import { DateTime } from 'luxon';
import { AsnResponse } from '../../Api/asn';

function getAsnLatestUpdate(asn: AsnResponse): DateTime | null {
  const dates = [
    asn.updated_at,
    ...asn.sku_configurations.map((sku) => sku.updated_at),
  ]
    .map((d) => DateTime.fromISO(d))
    .filter((dt) => dt.isValid);
  if (dates.length === 0) return null;
  return DateTime.max(...dates) as DateTime;
}

export function formatAsnLastEdited(asn: AsnResponse): string {
  const latest = getAsnLatestUpdate(asn);
  if (!latest) return 'Never';
  return latest.toFormat('LLL dd, yyyy');
}

export function formatAsnLastSaved(asn: AsnResponse): string {
  const latest = getAsnLatestUpdate(asn);
  if (!latest) return 'Never';
  return latest.toRelative() ?? latest.toFormat('LLL dd, yyyy');
}
